import { render } from "./SaleAttributionModal.vue?vue&type=template&id=47427cbc&scoped=true"
import script from "./SaleAttributionModal.vue?vue&type=script&lang=ts"
export * from "./SaleAttributionModal.vue?vue&type=script&lang=ts"

import "./SaleAttributionModal.vue?vue&type=style&index=0&id=47427cbc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47427cbc"

export default script